module.exports = require('./shorthash');